<template>
  <div id="page-user-edit">
    <vx-card v-if="operation_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="tab-text">
          <div id="user-edit-tab-info">
            <!-- Content Row -->
            <div class="vx-row">
              <div class="vx-col md:w-1/3 w-full">
                <vx-input-group class="mt-8">
                  <template slot="prepend">
                    <div class="prepend-text bg-primary">
                      <span>Transport ID #</span>
                    </div>
                  </template>
                  <vs-input v-model="operation_data.id" disabled size="default" />
                </vx-input-group>
                <div class="w-full mt-2" style="
                    background-color: #ffff99;
                    border: 1px solid #ffff99;
                    border-radius: 5px;
                  ">
                  <div style="font-size: 85%">Transporter</div>
                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <v-select style="background-color: #ffffff" autocomplete :options="data_option_people_name"
                        v-model="personId" :clearable="false" @input="getBillingAndDeliveryAddressList(true)" @clear="onClearTransporter" />
                    </div>
                  </div>
                </div>
                <div class="w-full mt-4" style="font-size: 85%">
                  <div>Transporter Billing Address</div>
                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <v-select :options="data_option_billing_address" v-model="billingAddressId" / :disabled="addressesLoading">
                      <!-- L'operation n'a pas d'adresse liee : on le DIT, au lieu de
                           choisir une adresse quelconque du client a sa place. -->
                      <span v-if="billingAddressUnlinked" class="text-warning text-sm">No billing address is recorded on this operation. The field above is only a suggestion: check it before saving.</span>
                    </div>
                  </div>
                </div>
                <p class="w-full mt-4" style="font-size: 85%">
                  &nbsp;Transport Date
                  <datepicker :inline="false" v-model="operation_data.date"></datepicker>
                </p>

                <div class="vx-row">
                  <div class="vx-col w-1/2" style="font-size: 85%">
                    <div class="w-full mt-4">Delivery date</div>
                    <datepicker :inline="false" v-model="dataTransitDate" @input="updateTransitPeriod"></datepicker>
                  </div>
                  <div class="vx-col w-1/2">
                    <vs-input name="number" label="Transit Period - default 7 (in days)" v-validate="'numeric'"
                      v-model="operation_data.transit_period" class="w-full mt-3" @input="updateDeliveryDate" />
                    <span class="text-danger text-sm" v-show="errors.has('number')">{{ errors.first("number") }}</span>
                  </div>
                </div>
              </div>
              <div class="vx-col md:w-1/3 w-full">
                <div class="w-full">
                  <vx-input-group class="mt-8">
                    <template slot="prepend">
                      <div class="prepend-text bg-primary">
                        <span>Invoice No</span>
                      </div>
                    </template>
                    <vs-input v-model="operation_data.transport_invoice_no" size="default" />
                  </vx-input-group>
                  <div class="vx-row">
                    <div class="vx-col w-1/2" style="font-size: 85%">
                      <vs-input name="cost" label="Transport cost (EUR)" v-validate="'numeric'" v-model="transportCost"
                        class="mt-2 w-full" style="background-color: #ffff99;border: 1px solid #ffff99;border-radius: 5px;
                        " />
                      <span class="text-danger text-sm" v-show="errors.has('cost')">{{ errors.first("cost") }}</span>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col w-full mt-3">
                      <div class="w-full"
                        style="background-color: #ffff99;border: 1px solid #ffff99;border-radius: 5px;">
                        <div style="font-size: 85%">Payment Method</div>
                        <v-select class="w-full" style="background-color: #ffffff" autocomplete
                          :options="payment_method" v-model="paymentmtd" />
                      </div>
                    </div>
                  </div>
                  <div class="vx-row">
                    <!--<div class="vx-col md:w-1/2 w-full" style="font-size: 85%">
                      <vs-input
                        class="w-full mt-3"
                        label="Date of receipt of documents"
                        v-model="operation_data.transport_invoice_date"
                        type="date"
                        name="birthday"
                      />
                    </div>-->
                    <div class="vx-col md:w-1/2 w-full" style="font-size: 85%"
                      v-if="paymentmtd && paymentmtd.value != 'direct'">
                      <vs-input class="w-full mt-3" label="Payment Date (estimate)"
                        v-model="operation_data.transport_invoice_due_date" type="date" name="birthday" />
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col w-1/2 mt-3">
                      <div style="font-size: 85%">Payment Status</div>
                      <div class="vx-row">
                        <div class="vx-col w-full">
                          <v-select :options="data_option_payment_status" v-model="statusId" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-col md:w-1/3 w-full">
                <div class="w-full">
                  <div class="vx-row">
                    <div class="vx-col w-1/2 mt-3">
                      <div class="w-full" style="
                          background-color: #ffff99;
                          border: 1px solid #ffff99;
                          border-radius: 5px;
                        ">
                        <div style="font-size: 85%">Transport Type</div>
                        <v-select class="w-full" style="background-color: #ffffff" autocomplete
                          :options="select_transport_type" v-model="transporttip" />
                      </div>
                    </div>
                    <div class="vx-col w-1/2 mt-3">
                      <div class="w-full" style="
                          background-color: #ffff99;
                          border: 1px solid #ffff99;
                          border-radius: 5px;
                        ">
                        <div style="font-size: 85%">Trailer Type</div>
                        <v-select style="background-color: #ffffff" class="w-full" autocomplete
                          :options="select_trailer_type" v-model="remorcatip" />
                      </div>
                    </div>
                  </div>
                  <!--<div class="vx-row">
                    <div class="vx-col w-1/2 mt-4" style="font-size: 85%">
                      <div
                        class="w-full"
                        style="
                          background-color: #ffff99;
                          border: 1px solid #ffff99;
                          border-radius: 5px;
                        "
                      >
                        Sumal Transport?
                        <vs-switch
                          class="w-full"
                          color="primary"
                          icon-pack="feather"
                          vs-icon-on="icon-yes"
                          vs-icon-off="icon-no"
                          v-model="operation_data.transport_sumal"
                        >
                          <span slot="on">YES</span>
                          <span slot="off">NO</span>
                        </vs-switch>
                      </div>
                    </div>
                  </div>-->
                  <div class="vx-row">
                    <div class="vx-col w-1/2 mt-2" style="font-size: 85%">
                      <div class="w-full" style="
                          background-color: #ffff99;
                          border: 1px solid #ffff99;
                          border-radius: 5px;
                        ">
                        <vs-input label="Weight (t)" v-model="operation_data.transport_tonaj" v-validate="'integer'"
                          class="w-full" name="weight" />
                        <span class="text-danger text-sm" v-show="errors.has('weight')">{{
                          errors.first("weight")
                          }}</span>
                      </div>
                    </div>
                    <div class="vx-col w-1/2 mt-2" style="font-size: 85%">
                      <div class="w-full" style="
                          background-color: #ffff99;
                          border: 1px solid #ffff99;
                          border-radius: 5px;
                        ">
                        <vs-input label="Floor length (ml)" v-model="operation_data.transport_podea_ml"
                          v-validate="'integer'" name="floor" class="w-full" />
                        <span class="text-danger text-sm" v-show="errors.has('floor')">{{
                          errors.first("floor")
                          }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col w-1/2" style="font-size: 85%">
                      <vs-input label="Truck Driver (name)" v-model="operation_data.driver" class="mt-2 w-full" />
                    </div>
                    <div class="vx-col w-1/2" style="font-size: 85%">
                      <vs-input label="Truck Driver (phone)" v-model="operation_data.driver_phone"
                        class="mt-2 w-full" />
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col w-1/2">
                      <vs-input label="Truck Plate" v-model="operation_data.truck_plate" class="mt-3 w-full" />
                    </div>
                    <div class="vx-col w-1/2">
                      <vs-input label="Trailer Plate" v-model="operation_data.trailer_plate" class="mt-3 w-full" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <br />
            <div id="data-list-list-view" class="data-list-container">
              <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar"
                :data="sidebarData" />

              <vs-table ref="table" :data="invoiceattached">
                <div slot="header" class="
                    flex flex-wrap-reverse
                    items-center
                    flex-grow
                    justify-between
                  ">
                  <div class="
                      flex flex-wrap-reverse
                      items-center
                      data-list-btn-container
                    ">
                    <div class="
                        btn-add-new
                        p-3
                        mt-8
                        mb-4
                        mr-4
                        rounded-lg
                        cursor-pointer
                        flex
                        items-center
                        justify-center
                        text-lg
                        font-medium
                        text-base text-primary
                        border border-solid border-primary
                      " @click="addNewData">
                      <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                      <span class="ml-2 text-base text-primary">Link Quotation</span>
                    </div>
                  </div>
                </div>

                <template slot="thead">
                  <vs-th>#</vs-th>
                  <vs-th>Quotation</vs-th>
                  <vs-th>Client</vs-th>
                  <vs-th>Destination</vs-th>
                  <vs-th>Aviz Number</vs-th>
                  <vs-th>Unloading Order</vs-th>
                  <vs-th>Action</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td>
                        <p class="font-medium truncate">
                          {{ indextr + 1 }}
                        </p>
                      </vs-td>

                      <vs-td>
                        <p class="font-medium truncate">REF #{{ tr.id }}</p>
                      </vs-td>

                      <vs-td>
                        <p>{{ tr.people }}</p>
                      </vs-td>

                      <vs-td>
                        <p>{{ tr.place_name }}, {{ tr.country }}</p>
                      </vs-td>

                      <vs-td>
                        <p>
                          Seria {{ tr.aviz_serie }}&nbsp;&nbsp; Nr.
                          {{ tr.aviz_number }}
                        </p>
                      </vs-td>
                      <vs-td>
                        <p>{{ tr.unloadingorder }}&nbsp;<span v-if="tr.unloadingorder == 1">(Last to be
                            loaded)</span><span v-if="invoiceattached.length == tr.unloadingorder">(First to be
                            loaded)</span></p>


                      </vs-td>
                      <vs-td class="whitespace-no-wrap">
                        <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                          @click.stop="editData(tr)" />
                        <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                          class="ml-2" @click.stop="unlinkInvoice(tr.id, tr.people)" />
                        <vs-button type="border" size="small" class="ml-2" @click.stop="previewEmailForQuotation(tr.id)">Preview email</vs-button>
                      </vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </div>
            <!-- Save & Reset Button -->
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="mt-8 flex flex-wrap items-center justify-end">
                  <!--<vs-button v-if="operation_data.isactive" type="border" color="danger" icon-pack="feather"
                    icon="icon-trash" @click="confirmDeleteRecord">Disable</vs-button>
                  <vs-button v-else type="border" color="success" icon-pack="feather" icon="icon-trash"
                    @click="confirmEnableRecord">Enable</vs-button>-->
                  <vs-button type="border" class="mr-3" @click="previewEmails" :disabled="saveInProgress || emailSendInProgress">Preview emails</vs-button>
                  <vs-button class="ml-auto" color="success" @click="save_changes" :disabled="!validateForm || addressesLoading || saveInProgress || emailSendInProgress">
                    {{ saveButtonText }}
                  </vs-button>
                </div>
                <br />
              </div>
            </div>
            <!-- Email Preview Modal -->
            <vs-popup title="Preview emails" :active.sync="showEmailPreview">
              <div class="w-full" v-if="emailPreviewItems && emailPreviewItems.length">
                <div class="vx-row mb-4">
                  <div class="vx-col w-full text-right">
                    <small>Success: {{ emailSendResults.success }} | Failed: {{ emailSendResults.fail }}</small>
                  </div>
                </div>
                <div class="vx-row" style="max-height: 60vh; overflow:auto;">
                  <div class="vx-col w-full" v-for="(item, idx) in emailPreviewItems" :key="'eml-'+idx">
                    <vx-card class="mb-4">
                      <div class="mb-2 flex items-center">
                        <strong class="mr-2">To:</strong>
                        <template v-if="item.emailOptions && item.emailOptions.length > 1">
                          <v-select style="min-width: 260px;" :options="item.emailOptions" v-model="item.toEmail" label="email" :reduce="o => o.email" :clearable="false">
                            <template #option="{ email, source }">
                              <span>{{ email }}</span>
                              <vs-chip :color="sourceChipColor(source)" size="small" class="ml-2">{{ sourceChipLabel(source) }}</vs-chip>
                            </template>
                          </v-select>
                        </template>
                        <template v-else>
                          <span>{{ item.toEmail }}</span>
                        </template>
                      </div>
                      <div class="mb-2"><strong>Subject:</strong> {{ item.subject }}</div>
                      <!-- Cc : Ferdinand + Mariana par l'écran, le broker des devis ajouté
                           par le serveur (operation_ids → helpers/brokerCc.js). -->
                      <div class="mb-2"><strong>Cc:</strong> ferdinand.terlinden@acaciabois.com, mariana.nagy@xyloimpact.com<span v-if="item.brokerCc">, {{ item.brokerCc }} (broker)</span><span v-else class="text-warning"> &mdash; no broker on these quotes</span></div>
                      <div class="mb-2"><strong>Quote(s):</strong> {{ item.quoteIds }}</div>
                      <pre style="white-space: pre-wrap;">{{ item.message }}</pre>
                    </vx-card>
                  </div>
                </div>
                <div class="mt-6 flex items-center justify-end">
                  <vs-button type="border" class="mr-3" @click="showEmailPreview=false">Close</vs-button>
                </div>
              </div>
              <div v-else>
                <p>No emails to send.</p>
              </div>
            </vs-popup>
            <div class="vx-row" style="padding: 20px">
              <GmapMap :center="center" :zoom="4" map-type-id="terrain" style="width: 100%; height: 500px">
                <GmapMarker :key="index" v-for="(m, index) in markers" :position="m" :clickable="false"
                  :draggable="false" @click="center = m" />
              </GmapMap>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import DataViewSidebar from "./DataViewSidebarAviz.vue";
import vSelect from "vue-select";
import axios from "@/axios.js";
import Datepicker from "vuejs-datepicker";
import moduleOperationList from "@/store/operation/moduleOperationList.js";
import addressSelection from "@/mixins/addressSelection";
import moment from "moment";
import { buildRecipientOptions, pickDefaultRecipients, sourceChipColor, sourceChipLabel } from "@/helpers/mail-recipients.js";
import eurRonRate from "@/mixins/eurRonRate";

export default {
  mixins: [eurRonRate, addressSelection],
  components: {
    DataViewSidebar,
    vSelect,
    Datepicker,
  },
  data() {
    return {
      firstload7days: true,
      paymentmtd: null,
      statusId: null,
      data_option_payment_status: [],
      dataTransitDate: null,
      operation_data: null,
      invoiceattached: null,
      data_option_people_name: [],
      //operation_data: JSON.parse(JSON.stringify(this.data)),
      selected: [],
      //itemsPerPage: 1000,
      isMounted: false,
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      buttonSubmitOpen: false,
      state: {},
      personId: null,
      initialPersonId: null, // Store initial transporter ID to detect changes
      initialLoadingDate: null, // Store initial loading date to detect changes
      initialQuotationCount: null, // Number of linked quotations on load (to detect "devis just attached")
      data_option_operation: [],
      linkedOperationId: [],
      data_option_billing_address: [],
      data_option_delivery_address: [],
      remorcatip: null,
      transporttip: null,
      billingAddressId: null,
      deliveryAddressId: null,
      transportCost: null,
      paymentDeadline: null,
      center: { lat: 50.0, lng: 12.0 },
      markers: [],
      // Email preview and sending state
      showEmailPreview: false,
      emailPreviewItems: [],
      emailSendInProgress: false,
      emailSendResults: { success: 0, fail: 0 },
      consolidateByClient: false,
      saveInProgress: false,
      select_transport_type: [
        { label: "Rutier", value: "Rutier" },
        { label: "Intermodal", value: "Intermodal" },
      ],
      select_trailer_type: [
        { label: "tautliner", value: "tautliner" },
        { label: "MEGA", value: "MEGA" },
      ],
      payment_method: [
        { label: "30 days from receipt of documents", value: "30 days" },
        { label: "Payment upon receipt of documents", value: "direct" },
        { label: "5 days from receipt of documents", value: "5 days" },
        { label: "10 days from receipt of documents", value: "10 days" },
        { label: "15 days from receipt of documents", value: "15 days" },
      ],
    };
  },
  computed: {
    products() {
      return this.$store.state.operationList.operationproducts;
    },
    hasTransportAndDelivery() {
      return !!(this.personId && this.personId.value && this.dataTransitDate);
    },
    canSendEmail() {
      return this.hasTransportAndDelivery &&
             this.invoiceattached &&
             this.invoiceattached.length > 0;
    },
    hasNewTransporter() {
      const currentPersonId = this.personId ? this.personId.value : null;
      const wasNoTransporter = !this.initialPersonId;
      return wasNoTransporter && currentPersonId;
    },
    hasLoadingDateChanged() {
      const initial = this.initialLoadingDate;
      const current = this.getEstimatedArrivalDate();
      if (!initial && !current) return false;
      return initial !== current;
    },
    // True when transporter+date were set first, then user attached quotations (so we must send once)
    hasQuotationsJustAttached() {
      const initial = this.initialQuotationCount != null ? this.initialQuotationCount : 0;
      const current = (this.invoiceattached && this.invoiceattached.length) || 0;
      return initial === 0 && current > 0;
    },
    shouldSendEmailOnSave() {
      if (!this.canSendEmail) return false;
      return this.hasNewTransporter || this.hasLoadingDateChanged || this.hasQuotationsJustAttached;
    },
    saveButtonText() {
      // Show loading state
      if (this.saveInProgress || this.emailSendInProgress) {
        if (this.emailSendInProgress) {
          return 'Sending emails...';
        }
        return 'Saving...';
      }
      // Show "Send Mail" if we need to notify about transporter assignment or date change
      if (this.shouldSendEmailOnSave) {
        return 'Save Changes + Send Mail';
      }
      return 'Save Changes';
    },
    validateForm() {
      return !this.errors.any();
    },
    currentPage() {
      if (this.isMounted) {
        if (this.operation_data.id) return this.$refs.table.currentx;
      }
      return 0;
    },
    queriedItems() {
      if (this.operation_data.id)
        return this.$refs.table
          ? this.$refs.table.queriedResults.length
          : this.users.length;
    },
  },
  methods: {
    sourceChipColor,
    sourceChipLabel,
    onClearTransporter() {
      this.personId = null;
      // Note: Don't reset initialPersonId here, we want to track if it was cleared
      this.billingAddressId = null;
      this.deliveryAddressId = null;
      this.data_option_billing_address = [];
      this.data_option_delivery_address = [];
    },
    async getSignatureQuote(language) {
      try {
        const langConfig = {
          fr: { logo: 'ab_fr.png', name: 'ACACIA BOIS', phone: 'Mobile BE:', phoneNumber: '+32 473 233 337', exhibitionTitle: 'Nous exposons:' },
          en: { logo: 'ab_en.png', name: 'ACACIA POLES', phone: 'Mobile BE:', phoneNumber: '+32 473 233 337', exhibitionTitle: 'Exhibiting:' },
          es: { logo: 'ab_es.png', name: 'ESTACAS DE ACACIA', phone: 'Móvil BE:', phoneNumber: '+32 473 233 337', exhibitionTitle: 'Exponemos:' },
          de: { logo: 'ab_de.png', name: 'ROBINIENPFÄHLE', phone: 'Handy DE:', phoneNumber: '+49 176 982 479 66', exhibitionTitle: 'Wir stellen aus:' },
          nl: { logo: 'ab_nl.png', name: 'ROBINIA PALEN', phone: 'Mobiel BE:', phoneNumber: '+32 473 23 33 37', exhibitionTitle: 'Wij exposeren:' },
        };
        const lang = (language || 'en').substring(0, 2).toLowerCase();
        // La langue arrive soit en code ('nl'), soit en nom ('Nederlands' -> 'ne')
        // selon l'ecran : sans cet alias, un client neerlandais retombait sur la
        // signature anglaise (logo ACACIA POLES) sous un corps de mail en NL.
        const config = langConfig[lang === 'ne' ? 'nl' : lang] || langConfig.en;

        let exhibitionHtml = '';
        try {
          const response = await axios.get('https://xylo.codesinn.com/signature/salon_selection.json');
          const selectedImages = response.data.selected_images || [];
          if (selectedImages.length > 0) {
            const timestamp = Date.now();
            const imageHtml = selectedImages.map(imageName => `
              <div style="margin-bottom: 10px; padding: 8px; background-color: #fff; border: 1px solid #ddd;">
                <div style="margin-bottom: 8px; text-align: center;">
                  <img src="https://xylo.codesinn.com/signature/upload/${imageName}?t=${timestamp}" alt="Salon Logo" style="display: block; max-width: 100%; height: auto;" />
                </div>
              </div>
            `).join('');
            exhibitionHtml = `
<table width="100%" cellpadding="0" cellspacing="0" border="0" style="width: 100%; border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
  <tr>
    <td align="left" style="padding: 0;">
      <table width="420" cellpadding="0" cellspacing="0" border="0" style="width: 420px; border-collapse: collapse; font-family: Arial, sans-serif; color: #333; margin-top: 10px; border: 1px solid #e0e0e0; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
        <tr>
          <td style="padding: 8px; background-color: #f8f9fa; border-top: 2px solid #0073b1;">
            <div style="font-size: 13px; font-weight: bold; color: #0073b1; margin-bottom: 8px; text-align: left;">
              ${config.exhibitionTitle}
            </div>
            ${imageHtml}
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>`;
          }
        } catch (error) {
          // ignore
        }

        return `<div style="text-align: left; width: 100%; margin: 0;">
<table width="100%" cellpadding="0" cellspacing="0" border="0" style="width: 100%; border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
  <tr>
    <td align="left" style="padding: 0;">
      <table width="420" cellpadding="0" cellspacing="0" border="0" style="width: 420px; border-collapse: collapse; font-family: Arial, sans-serif; color: #333; line-height: 1.4; border-top: 2px solid #0073b1; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
        <tr>
          <td style="vertical-align: middle; padding: 10px 15px 10px 10px; width: 120px;">
            <img src="https://xylo.codesinn.com/image/${config.logo}" alt="${config.name} Logo" style="display: block;" />
          </td>
          <td style="vertical-align: top; padding: 10px 10px 10px 0;">
            <div style="font-size: 13px; color: #333; font-weight: bold; margin-bottom: 8px;">${config.name}</div>            <div style="margin-bottom: 8px;">
              <div><a href="https://www.acaciabois.com" target="_blank" style="text-decoration: none; color: #0073b1;">www.acaciabois.com</a></div>
            </div>
            <div style="margin-bottom: 0;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                <tr>
                  <td style="padding-right: 8px; vertical-align: middle;">
                    <a href="https://www.instagram.com/acaciabois/" target="_blank" style="text-decoration: none;">
                      <img src="https://xylo.codesinn.com/image/instagram.png" alt="Instagram" style="display: block; border: 0;" />
                    </a>
                  </td>
                  <td style="padding-right: 8px; vertical-align: middle;">
                    <a href="https://www.facebook.com/acacia.bois.piquets/" target="_blank" style="text-decoration: none;">
                      <img src="https://xylo.codesinn.com/image/facebook.png" alt="Facebook" style="display: block; border: 0;" />
                    </a>
                  </td>
                  <td style="padding-right: 8px; vertical-align: middle;">
                    <a href="https://www.linkedin.com/company/acacia-bois" target="_blank" style="text-decoration: none;">
                      <img src="https://xylo.codesinn.com/image/linkedin.png" alt="LinkedIn" style="display: block; border: 0;" />
                    </a>
                  </td>
                  <td style="vertical-align: middle;">
                    <a href="https://g.page/r/CQ5mo8xGMDriEBM/review" target="_blank" style="text-decoration: none;">
                      <img src="https://xylo.codesinn.com/image/google.png" alt="Google" style="display: block; border: 0;" />
                    </a>
                  </td>
                </tr>
              </table>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2" style="padding: 10px; border-top: 1px solid #ccc;">
            <div style="font-size: 9px; color: #777; text-align: left; line-height: 1.2;">
              FSC &reg; CERTIFIED (SGSCH-COC-011793) | ISO9001-2015 CERTIFIED
            </div>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>
${exhibitionHtml}
</div>`;
      } catch (error) {
        return '';
      }
    },
    async getPaymentStatus() {
      axios.get("/salestatus/data").then((response) => {
        this.data_option_payment_status = [...response.data];
        if (this.operation_data.salestatus) {
          const ItemIndex = this.data_option_payment_status.findIndex(
            (p) => p.value === this.operation_data.salestatus.id
          );
          this.statusId = this.data_option_payment_status.splice(ItemIndex, 1);
        } else {
          this.statusId = this.data_option_payment_status.splice(2, 1);
        }
      });
    },
    updateTransitPeriod() {
      var start = moment(this.operation_data.date);
      var end = moment(this.dataTransitDate);
      this.operation_data.transit_period = Math.floor((end - start) / 86400000);
    },
    updateDeliveryDate() {
      if (!this.operation_data.transit_period && this.firstload7days) {
        this.operation_data.transit_period = 7
        this.firstload7days = false
      }
      var start = moment(this.operation_data.date).add(
        this.operation_data.transit_period,
        "days"
      );
      this.dataTransitDate = moment(start).toString("YYYY-MM-DD");
    },
    async recalculateMap() {
      axios
        .get("/getpersonaddressmap/" + this.$route.params.userId)
        .then((response) => {
          this.markers = response.data;
          this.center = response.data[0];
        });
    },
    // Les deux listes d'options d'abord (Promise.all), la selection ENSUITE.
    // Avant, la resolution de la selection etait lancee depuis chacun des deux
    // .then() : quatre requetes concurrentes, et la premiere tournait contre une
    // liste d'options encore vide. Deux vagues, un seul ordre possible.
    //
    // `personChanged` = le contact vient d'etre change dans le v-select. On ne
    // relit alors PAS l'adresse liee a l'operation : elle appartient encore a
    // l'ANCIEN contact, et la reinjecter dans les options du nouveau est
    // exactement le « l'adresse a saute » signale. On propose l'adresse par
    // defaut du nouveau contact, visible dans le v-select avant tout Save.
    async getBillingAndDeliveryAddressList(personChanged = false) {
      if (!this.personId || !this.personId.value) {
        this.billingAddressId = null;
        this.deliveryAddressId = null;
        this.data_option_billing_address = [];
        this.data_option_delivery_address = [];
        return;
      }
      this.billingAddressId = null;
      this.deliveryAddressId = null;
      this.billingAddressUnlinked = false;
      this.deliveryAddressUnlinked = false;
      this._beginAddressLoading();
      try {
        const [billing, delivery] = await Promise.all([
          axios.get("/person/getaddressbilling/" + this.personId.value).catch(() => ({ data: [] })),
          axios.get("/person/getaddressdelivery/" + this.personId.value).catch(() => ({ data: [] })),
        ]);
        this.data_option_billing_address = [...((billing && billing.data) || [])];
        this.data_option_delivery_address = [...((delivery && delivery.data) || [])];
        await this.getSelectedBillingAndDeliveryAddressList(personChanged);
      } finally {
        this._endAddressLoading();
      }
    },
    // `personChanged` : voir getBillingAndDeliveryAddressList. Les deux
    // chaines sont RENVOYEES, donc reellement attendues par l'appelant —
    // avant, elles partaient en fire-and-forget et le drapeau de chargement
    // retombait a faux alors que les adresses n'etaient pas encore resolues.
    async getSelectedBillingAndDeliveryAddressList(personChanged = false) {
      const billingChain = (personChanged
          ? Promise.reject(new Error("contact changed: no linked address to re-read"))
          : axios.get("/person/getaddressbilling/" + this.personId.value + "/" + this.$route.params.userId))
          .then((response) => {
            // The address this operation is actually linked to. pickAddressOption
            // injects it when it is missing from the options instead of silently
            // selecting options[0] — which was then saved over the real address.
            const selectedAddress = response.data[0];
            if (!selectedAddress || selectedAddress.value == null)
              throw new Error("no address linked to this operation");
            this.billingAddressId = this.pickAddressOption(this.data_option_billing_address, selectedAddress);
            this.billingAddressUnlinked = false;
          })
          .catch((error) => {
            // Ne l'annoncer que quand c'est VRAI : un echec reseau tombe dans ce
            // meme catch, et dire alors « aucune adresse enregistree » serait faux.
            this.billingAddressUnlinked = /no address linked|contact changed/.test(
              (error && error.message) || "");
            if (!this.billingAddressId)
              this.billingAddressId = this.proposeAddressOption(this.data_option_billing_address);
          });

      const deliveryChain = (personChanged
          ? Promise.reject(new Error("contact changed: no linked address to re-read"))
          : axios.get("/person/getaddressdelivery/" + this.personId.value + "/" + this.$route.params.userId))
          .then((response) => {
            // The address this operation is actually linked to. pickAddressOption
            // injects it when it is missing from the options instead of silently
            // selecting options[0] — which was then saved over the real address.
            const selectedAddress = response.data[0];
            if (!selectedAddress || selectedAddress.value == null)
              throw new Error("no address linked to this operation");
            this.deliveryAddressId = this.pickAddressOption(this.data_option_delivery_address, selectedAddress);
            this.deliveryAddressUnlinked = false;
          })
          .catch((error) => {
            // Ne l'annoncer que quand c'est VRAI : un echec reseau tombe dans ce
            // meme catch, et dire alors « aucune adresse enregistree » serait faux.
            this.deliveryAddressUnlinked = /no address linked|contact changed/.test(
              (error && error.message) || "");
            if (!this.deliveryAddressId)
              this.deliveryAddressId = this.proposeAddressOption(this.data_option_delivery_address);
          });

      return Promise.all([billingChain, deliveryChain]);
    },
    calculateTotal() {
      this.dataTotalPrice = this.dataUnitPrice * this.dataQuantity;
    },
    async getPeople() {
      axios.get("/people_name/data").then((response) => {
        this.data_option_people_name = [...response.data];
        // Guard: operation may have no linked people
        if (!this.operation_data || !this.operation_data.people || !this.operation_data.people.length) {
          this.personId = null;
          return;
        }
        const ItemIndex = this.data_option_people_name.findIndex(
          (p) => p.value === this.operation_data.people[0].id
        );
        if (ItemIndex >= 0) {
          this.personId = this.data_option_people_name.splice(ItemIndex, 1)[0];
          // Store initial transporter ID to detect changes
          this.initialPersonId = this.personId ? this.personId.value : null;
          this.getBillingAndDeliveryAddressList();
        } else {
          this.personId = null;
          this.initialPersonId = null;
        }
      });
    },
    confirmDeleteRecord() {
      let namealert =
        this.operation_data.operationcategory.name_en +
        " #" +
        this.operation_data.id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Disable",
        text: `You are about to disable ${namealert}`,
        accept: this.deleteRecord,
        acceptText: "Disable",
      });
    },
    confirmEnableRecord() {
      let namealert =
        this.operation_data.operationcategory.name_en +
        " #" +
        this.operation_data.id;
      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: "Confirm Enable",
        text: `You are about to re-enable ${namealert}`,
        accept: this.enableRecord,
        acceptText: "Enable",
      });
    },
    enableRecord() {
      this.invoiceattached.forEach(e => {
        axios
          .post("/operation/enable", { id: e.id })
          .catch((err) => {
          this.showActionFailed(err);
        });
      });
      axios
        .post("/operation/enable", { id: this.operation_data.id })
        .catch((err) => {
          this.showActionFailed(err);
        });
      this.$router.push({ path: "/transport/" + this.operation_data.id });
      this.showEnableSuccess();
    },
    // Les .catch vides masquaient tout echec de /operation/enable|disable :
    // l'ecran affichait « successfully deleted » et l'operation etait toujours la.
    showActionFailed(err) {
      console.error("operation enable/disable:", err);
      const data = err && err.response && err.response.data;
      this.$vs.notify({
        color: "danger",
        title: "Action NOT applied",
        text: (data && (data.message || data.error)) || (err && err.message) ||
          "The server refused the operation. Reload the page to see its real state.",
        time: 12000,
      });
    },
    showEnableSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Operation Enable",
        text: "The selected operation was successfully enabled",
      });
    },
    deleteRecord() {
      this.invoiceattached.forEach(e => {
        axios
          .post("/operation/disable", { id: e.id })
          .catch((err) => {
          this.showActionFailed(err);
        });
      });
      axios
        .post("/operation/disable", { id: this.operation_data.id })
        .catch((err) => {
          this.showActionFailed(err);
        });
      this.$router.push({ path: "/transport/" + this.operation_data.id });
      this.showDeleteSuccess();
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Operation Deleted",
        text: "The selected operation was successfully deleted",
      });
    },
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    addNewData() {
      if (this.operation_data.id) {
        var idtransport = this.operation_data.id;
        var datetransport = this.operation_data.date;
        this.sidebarData = { idtransport, datetransport };
        this.toggleDataSidebar(true);
      } else {
        this.$vs.notify({
          color: "alert",
          title: "Alert!",
          text: "Please select a Person before!",
        });
      }
    },
    save_changes() {
      // Un enregistrement lance pendant le chargement des adresses partait avec
      // une adresse nulle — ou pire, celle de l'ANCIEN contact.
      const addressBlocked = this.addressSaveBlockReason();
      if (addressBlocked) {
        this.$vs.notify({ color: "warning", title: "Please wait", text: addressBlocked });
        return;
      }
      // Prevent multiple clicks
      if (this.saveInProgress || this.emailSendInProgress) {
        return;
      }

      if (this.operation_data.transit_period != null) {
        this.saveInProgress = true;
        var personIdentifiant = null;
        if (this.personId) {
          personIdentifiant = this.personId.value;
        } else {
          personIdentifiant = null;
        }
        const objprod = {
          idoperation: this.operation_data.id,
          description: "Transport",
          idproduct: 1,
          quantity: 1,
          price: -Math.abs(this.transportCost),
          price_ron: -Math.abs(
            this.transportCost * localStorage.getItem("rate_eur_ron")
          ),
          who: localStorage.getItem("login-username"),
        };
        this.$store
          .dispatch("operationList/updateTransportCost", objprod)
          .then((res) => {
            let transit = null;
            if (this.operation_data.transit_period) {
              transit = this.operation_data.transit_period;
              if (this.operation_data.transit_period === '0') transit = null;
            } else transit = '0';
            let _idbilling = null;
            if (this.billingAddressId) {
              _idbilling = this.billingAddressId.value;
            }

            let transporttiplt = null
            if (this.transporttip) transporttiplt = this.transporttip.value
            let remorcatiplt = null
            if (this.remorcatip) remorcatiplt = this.remorcatip.value

            let str_transport_method = null
            if (this.paymentmtd) str_transport_method = this.paymentmtd.value
            if (str_transport_method == 'direct') this.operation_data.transport_invoice_due_date = null
            else if (str_transport_method == '30 days');
            else this.operation_data.transport_invoice_due_date = null

            // Normalize statusId (can be object or single-item array)
            const statusVal = this.statusId
              ? (Array.isArray(this.statusId) ? (this.statusId[0] ? this.statusId[0].value : null) : this.statusId.value)
              : null;
            const obj = {
              id: this.operation_data.id,
              idperson: personIdentifiant,
              date: moment(this.operation_data.date),
              driver: this.operation_data.driver,
              idsalestatus: statusVal,
              driver_phone: this.operation_data.driver_phone,
              truck_plate: this.operation_data.truck_plate,
              trailer_plate: this.operation_data.trailer_plate,
              transit_period: transit,
              idbilling: _idbilling,
              transport_invoice_date: this.operation_data.transport_invoice_date ? moment(this.operation_data.transport_invoice_date) : null,
              transport_invoice_due_date: this.operation_data.transport_invoice_due_date ? moment(this.operation_data.transport_invoice_due_date) : null,
              transport_invoice_no: this.operation_data.transport_invoice_no,
              transport_podea_ml: this.operation_data.transport_podea_ml,
              transport_tonaj: this.operation_data.transport_tonaj,
              transport_sumal: this.operation_data.transport_sumal,
              transport_tip: transporttiplt,
              transport_remorca_type: remorcatiplt,
              transport_payment_method: str_transport_method,
              who: localStorage.getItem("login-username"),
            };
            // Prune only invalid dates; keep idperson/idbilling even if null so backend can unset
            if (!obj.transport_invoice_date) delete obj.transport_invoice_date;
            if (!obj.transport_invoice_due_date) delete obj.transport_invoice_due_date;
            console.log(obj);

            if (this.operation_data.id) {
              this.$store
                .dispatch("operationList/updateOperation", obj)
                .then(async () => {
                  // Determine email sending logic based on transporter assignment and date changes
                  const currentPersonId = this.personId ? this.personId.value : null;
                  const hasTransporter = !!(currentPersonId);
                  const hasDate = !!(this.dataTransitDate);

                  // Case 1: No transporter AND no date → don't send email
                  if (!hasTransporter || !hasDate) {
                    this.saveInProgress = false;
                    this.$vs.notify({
                      color: "success",
                      title: "Operation Updated!",
                      text: "The transport was successfully updated",
                    });
                    // Redirect after successful save (including when transporter is removed)
                    this.initialPersonId = currentPersonId;
                    this.initialLoadingDate = this.getEstimatedArrivalDate();
                    this.$router.push({ name: "transport/transport-view" });
                    return;
                  }

                  // Always refresh linked quotations so we see devis just attached (transporter+date were set before)
                  await this.fetch_invoice_linked_data(this.$route.params.userId);

                  // Case 2, 3 & 4: We have transporter and date, check if we should send email
                  const wasNoTransporter = !this.initialPersonId;
                  const isNewTransporter = wasNoTransporter && hasTransporter;
                  const hasDateChanged = this.hasLoadingDateChanged;
                  const hasQuotationsJustAttached = this.hasQuotationsJustAttached;

                  // Send email if: new transporter OR date changed OR devis just attached (transporter+date were set first)
                  if (isNewTransporter || hasDateChanged || hasQuotationsJustAttached) {
                    // Only send email if there are linked quotations (list is already fresh)
                    if (!this.invoiceattached || !this.invoiceattached.length || this.invoiceattached.length === 0) {
                      this.saveInProgress = false;
                      this.$vs.notify({ color: 'warning', title: 'No quotations linked', text: 'Cannot send email without linked quotations.' });
                      // Redirect even if no quotations linked
                        this.initialPersonId = currentPersonId;
                        this.initialLoadingDate = this.getEstimatedArrivalDate();
                      this.$router.push({ name: "transport/transport-view" });
                    } else {
                      // Build items before sending to avoid "No emails"
                      // Use date change email only when date changed (not for new transporter or devis just attached)
                      const useDateChangeEmail = !isNewTransporter && hasDateChanged && !hasQuotationsJustAttached;
                      try {
                        let items = await this.buildEmailPreviewItems(useDateChangeEmail);
                        this.emailPreviewItems = items || [];
                        console.log(`[Email Transport] Built ${this.emailPreviewItems.length} email preview item(s)`);
                      } catch (e) {
                        console.error(`[Email Transport] Error building email preview items:`, e);
                        this.emailPreviewItems = [];
                      }
                      if (this.emailPreviewItems && this.emailPreviewItems.length) {
                        // Reset saveInProgress before sending emails - emailSendInProgress will keep button disabled
                        this.saveInProgress = false;
                        const emailSent = await this.sendTransportEmails();
                        // Redirect after email sending (always redirect, whether emails were sent or not)
                        this.initialPersonId = currentPersonId;
                        this.initialLoadingDate = this.getEstimatedArrivalDate();
                        this.$router.push({ name: "transport/transport-view" });
                      } else {
                        this.saveInProgress = false;
                        console.warn(`[Email Transport] No emails to send after building preview items. Linked quotations: ${(this.invoiceattached && this.invoiceattached.length) || 0}`);
                        this.$vs.notify({ 
                          color: 'warning', 
                          title: 'No emails to send', 
                          text: 'No emails could be generated. This may be due to missing email addresses for clients or errors fetching quotation data. Please check the browser console for details.' 
                        });
                        // Redirect even if no emails to send
                        this.initialPersonId = currentPersonId;
                        this.initialLoadingDate = this.getEstimatedArrivalDate();
                        this.$router.push({ name: "transport/transport-view" });
                      }
                    }
                  } else {
                    // No email to send, just show success notification
                    this.saveInProgress = false;
                    this.$vs.notify({
                      color: "success",
                      title: "Operation Updated!",
                      text: "The transport was successfully updated",
                    });
                    // Redirect after successful save
                    this.initialPersonId = currentPersonId;
                    this.initialLoadingDate = this.getEstimatedArrivalDate();
                    this.$router.push({ name: "transport/transport-view" });
                  }
                })
                .catch((err) => {
                  this.saveInProgress = false;
                  console.error(err);
                  this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    text: "An error occurred while saving. Please try again.",
                  });
                });
            } else {
              this.saveInProgress = false;
            }
          })
          .catch((err) => {
            this.saveInProgress = false;
            console.error(err);
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: "An error occurred while updating transport cost. Please try again.",
            });
          });
      } else {
        this.$vs.notify({
          color: "danger",
          title: "Transit Period Required!",
          text: "Please input a transit period",
        });
      }
    },
    showUnlinkSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Quotation Unlinked",
        text: "The Quotation was successfully unlinked",
      });
    },
    unlinkInvoiceOne(invoiceId) {
      console.log("🔴 unlinkInvoiceOne appelé avec invoiceId:", invoiceId);
      if (this.invoiceattached && Array.isArray(this.invoiceattached)) {
        const invoiceList = this.invoiceattached.map(function(inv) {
          return { id: inv.id, people: inv.people };
        });
        console.log("🔴 Liste actuelle des invoices:", invoiceList);
      } else {
        console.log("🔴 Liste des invoices est vide ou undefined");
      }

      const obj = {
        idtransport: this.operation_data.id,
        idinvoice: invoiceId,
        /*aviz_serie: this.dataAvizSerie,
        aviz_number: this.dataAvizNumber,*/
        delete: true,
        who: localStorage.getItem("login-username"),
      };
      console.log("🔴 Objet envoyé au store:", JSON.stringify(obj));

      this.$store
        .dispatch("operationList/UnlinkOperationToTransport", obj)
        .then((response) => {
          console.log("✅ Réponse du store:", response);
          console.log("✅ Invoice déliée avec succès, ID:", invoiceId);
          this.$vs.notify({
            color: "success",
            title: "Quotation unlinked",
            text: "The selected Quotation was successfully unlinked",
          });
          // Recharger les données après suppression
          this.fetch_invoice_linked_data(this.$route.params.userId);
        })
        .catch((err) => {
          console.error("❌ Erreur lors du déliage:", err);
          console.error("❌ InvoiceId qui a causé l'erreur:", invoiceId);
        });
    },
    unlinkInvoice(id, name) {
      console.log("🟢 unlinkInvoice appelé avec:");
      console.log("  - id:", id);
      console.log("  - name:", name);
      if (this.invoiceattached && Array.isArray(this.invoiceattached)) {
        const invoiceList = this.invoiceattached.map(function(inv) {
          return { id: inv.id, people: inv.people };
        });
        console.log("  - Liste complète des invoices:", invoiceList);
      }

      // Capture l'ID dans une closure pour éviter qu'il soit écrasé
      const invoiceId = id;
      console.log("🟢 invoiceId capturé dans closure:", invoiceId);

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Unlink",
        text: `You are about to unlink the Quotation of ${name}`,
        accept: function() {
          console.log("🟡 Accept cliqué, invoiceId dans closure:", invoiceId);
          this.unlinkInvoiceOne(invoiceId);
        }.bind(this),
        acceptText: "Unlink Quotation",
      });
    },
    editData(data) {
      data.idtransport = this.operation_data.id;
      data.datetransport = this.operation_data.date;
      data.aviz_number = data.aviz_number;
      data.aviz_serie = data.aviz_serie;
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    getActiveColors(status) {
      if (status === "true") return "primary";
      if (status === false) return "danger";
      return "warning";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
      // When closing sidebar, refresh linked quotations so "devis just attached" is detected on next Save
      if (!val && this.$route.params.userId) {
        this.fetch_invoice_linked_data(this.$route.params.userId);
      }
    },
    fetch_operation_data(userId) {
      if (userId) {
        this.$store
          .dispatch("operationList/fetchOperation", userId)
          .then((res) => {
            this.operation_data = res.data;
            const fetchedDate = moment(res.data.date);
            this.initialLoadingDate = fetchedDate.isValid() ? fetchedDate.format('YYYY-MM-DD') : null;
            this.updateDeliveryDate();
            this.getPeople();

            this.getPaymentStatus();
            this.transportCost = Math.abs(
              res.data.products[0].operations_products.unit_price
            );

            const ItemIndex = this.select_trailer_type.findIndex(
              (p) => p.value === res.data.transport_remorca_type
            );
            this.remorcatip = this.select_trailer_type[ItemIndex];

            const ItemIndexTruck = this.select_transport_type.findIndex(
              (p) => p.value === res.data.transport_tip
            );
            this.transporttip = this.select_transport_type[ItemIndexTruck];

            const ItemIndexPaymentMtd = this.payment_method.findIndex(
              (p) => p.value === res.data.transport_payment_method
            );
            this.paymentmtd = this.payment_method[ItemIndexPaymentMtd];

            this.$store
              .dispatch(
                "operationList/fetcheurdifference",
                this.$route.params.userId
              )
              .catch((err) => {
                if (err.response.status === 404) {
                  this.user_not_found = true;
                  return;
                }
                console.error(err);
              });
          })
          .catch((err) => {
            if (err.response.status === 404) {
              this.user_not_found = true;
              return;
            }
            console.error(err);
          });
      } else {
        this.operation_data = {};
        this.initialLoadingDate = null;
      }
    },
    fetch_invoice_linked_data(userId) {
      if (userId) {
        return this.$store
          .dispatch("operationList/fetchInvoiceLinked", userId)
          .then((res) => {
            this.invoiceattached = res.data;
            this.markers = res.data;
            // Set initial count only on first load (so "devis just attached" works: 0 -> N triggers send once)
            if (this.initialQuotationCount === null) {
              this.initialQuotationCount = (res.data && Array.isArray(res.data)) ? res.data.length : 0;
            }
            return res;
          });
      } else {
        this.invoiceattached = {};
        this.initialQuotationCount = 0;
        return Promise.resolve();
      }
    },
    // ===================== EMAIL SENDING LOGIC =====================
    getClientLanguageCode(person) {
      try {
        const name = person && person.language && person.language.name ? person.language.name.toLowerCase() : '';
        if (name.startsWith('fr')) return 'fr';
        if (name.startsWith('ro')) return 'ro';
        if (name.startsWith('de')) return 'de';
        if (name.startsWith('es')) return 'es';
        if (name.startsWith('nl') || name.startsWith('ne')) return 'nl';
        return 'en';
      } catch (e) { return 'en'; }
    },
    getDeliveryAddressLabel() {
      if (this.deliveryAddressId && (this.deliveryAddressId.label || this.deliveryAddressId.text)) {
        return this.deliveryAddressId.label || this.deliveryAddressId.text;
      }
      if (this.data_option_delivery_address && this.data_option_delivery_address.length) {
        return this.data_option_delivery_address[0].label || this.data_option_delivery_address[0].text || '';
      }
      return "(non précisée)";
    },
    async getDeliveryAddressLabelFor(personId, operationId) {
      try {
        if (personId && operationId) {
          const resp = await axios.get(`/person/getaddressdeliverydetails/${personId}/${operationId}`);
          if (resp && resp.data && resp.data[0]) {
            const a = resp.data[0];
            // Try standard label/text first if provided by API
            if (a.label || a.text) return (a.label || a.text);
            // Otherwise build from parts if available
            const street = a.street || '';
            const number = a.nr ? ` ${a.nr}` : (a.number ? ` ${a.number}` : '');
            const postal = a.cp || a.postal_code || a.postal || '';
            const city = a.place || a.place_name || a.city || '';
            const region = a.region || a.province || '';
            const country = a.country || a.country_name || '';
            const parts = [];
            const line1 = `${street}${number}`.trim();
            if (line1) parts.push(line1);
            const line2 = `${postal} ${city}`.trim();
            if (line2) parts.push(line2);
            if (region) parts.push(region);
            if (country) parts.push(country);
            if (parts.length) return parts.join(', ');
          }
        }
      } catch (e) { /* ignore and fallback */ }
      return this.getDeliveryAddressLabel();
    },
    getEstimatedArrivalDate() {
      try {
        const m = moment(this.operation_data.date);
        if (!m.isValid()) return '';
        return m.format('YYYY-MM-DD');
      } catch (e) { return ''; }
    },
    getDeliveryDate() {
      try {
        if (this.dataTransitDate) {
          return moment(this.dataTransitDate).format('YYYY-MM-DD');
        }
        // Fallback to estimated arrival date if delivery date not set
        return this.getEstimatedArrivalDate();
      } catch (e) { return ''; }
    },
    formatDateForLang(dateStr, lang) {
      try {
        const loc = ['fr','en','de','es','nl','ro'].includes(lang) ? lang : 'en';
        return moment(dateStr).locale(loc).format('LL');
      } catch (e) { return dateStr; }
    },
    localizeEmail(lang, vars) {
      const prettyDate = this.formatDateForLang(vars.estimatedDate, lang);
      const dict = {
        fr: {
          subject: `Organisation transport - Commande ${vars.quoteIds}`,
          hello: `Bonjour,`,
          body: `Le transport avec votre commande ${vars.quoteIds} est organisé.\n\nAdresse de livraison: ${vars.deliveryAddress}\nDate estimée de chargement: ${prettyDate}.\nVous recevrez un email de confirmation avec la facture finale lorsque le camion aura été chargé.\n\nMerci de vérifier l'accès pour un camion semi-remorque de 40t.`,
          goodbye: `Bien à vous,`
        },
        en: {
          subject: `Quote ${vars.quoteIds} - Transport assigned`,
          hello: `Hello,`,
          body: `The transport for your order ${vars.quoteIds} has been arranged.\n\nDelivery address: ${vars.deliveryAddress}\nEstimated loading date: ${prettyDate}\n\nPlease verify access for a 40t semi-trailer truck.`,
          goodbye: `Best regards,`
        },
        ro: {
          subject: `Ofertă ${vars.quoteIds} - Transport asignat`,
          hello: `Bună ziua,`,
          body: `Transportul pentru comanda dvs. ${vars.quoteIds} este organizat.\n\nAdresa de livrare: ${vars.deliveryAddress}\nData estimată de încărcare: ${prettyDate}\n\nVă rugăm să verificați accesul pentru un camion semiremorcă de 40t.`,
          goodbye: `Cu stimă,`
        },
        de: {
          subject: `Angebot ${vars.quoteIds} - Transport zugewiesen`,
          hello: `Guten Tag,`,
          body: `Der Transport für Ihre Bestellung ${vars.quoteIds} ist organisiert.\n\nLieferadresse: ${vars.deliveryAddress}\nVoraussichtliches Lade-Datum: ${prettyDate}\n\nBitte prüfen Sie die Zufahrt für einen 40t-Sattelzug.`,
          goodbye: `Mit freundlichen Grüßen,`
        },
        es: {
          subject: `Presupuesto ${vars.quoteIds} - Transporte asignado`,
          hello: `Hola,`,
          body: `El transporte de su pedido ${vars.quoteIds} está organizado.\n\nDirección de entrega: ${vars.deliveryAddress}\nFecha estimada de carga: ${prettyDate}\n\nPor favor, verifique el acceso para un camión tráiler de 40t.`,
          goodbye: `Saludos cordiales,`
        },
        nl: {
          subject: `Offerte ${vars.quoteIds} - Transport toegewezen`,
          hello: `Hallo,`,
          body: `Het transport voor uw bestelling ${vars.quoteIds} is geregeld.\n\nAfleveradres: ${vars.deliveryAddress}\nGeschatte laad datum: ${prettyDate}\n\nControleer a.u.b. de toegang voor een 40-tons trekker-oplegger.`,
          goodbye: `Met vriendelijke groet,`
        },
      };
      const d = dict[lang] || dict['en'];
      return {
        subject: d.subject,
        message: `${d.hello}\n\n${d.body}\n\n${d.goodbye}`
      };
    },
    localizeEmailDateChange(lang, vars) {
      const prettyDate = this.formatDateForLang(vars.estimatedDate, lang);
      const dict = {
        fr: {
          subject: `Mise à jour date de chargement - Commande ${vars.quoteIds}`,
          hello: `Bonjour,`,
          body: `Nous avons mis à jour la date de chargement de votre commande ${vars.quoteIds}.\n\nNouvelle date estimée de chargement: ${prettyDate}.\nMerci de vérifier l'accès pour un camion semi-remorque de 40t.`,
          goodbye: `Bien à vous,`
        },
        en: {
          subject: `Loading date updated - Quote ${vars.quoteIds}`,
          hello: `Hello,`,
          body: `We have updated the loading date for your order ${vars.quoteIds}.\n\nNew estimated loading date: ${prettyDate}.\nPlease verify access for a 40t semi-trailer truck.`,
          goodbye: `Best regards,`
        },
        ro: {
          subject: `Data de încărcare actualizată - Ofertă ${vars.quoteIds}`,
          hello: `Bună ziua,`,
          body: `Am actualizat data de încărcare pentru comanda dvs. ${vars.quoteIds}.\n\nNoua dată estimată de încărcare: ${prettyDate}.\nVă rugăm să verificați accesul pentru un camion semiremorcă de 40t.`,
          goodbye: `Cu stimă,`
        },
        de: {
          subject: `Ladedatum aktualisiert - Angebot ${vars.quoteIds}`,
          hello: `Guten Tag,`,
          body: `Wir haben das Ladedatum für Ihre Bestellung ${vars.quoteIds} aktualisiert.\n\nNeues voraussichtliches Ladedatum: ${prettyDate}.\nBitte prüfen Sie die Zufahrt für einen 40t-Sattelzug.`,
          goodbye: `Mit freundlichen Grüßen,`
        },
        es: {
          subject: `Fecha de carga actualizada - Presupuesto ${vars.quoteIds}`,
          hello: `Hola,`,
          body: `Hemos actualizado la fecha de carga de su pedido ${vars.quoteIds}.\n\nNueva fecha estimada de carga: ${prettyDate}.\nPor favor, verifique el acceso para un camión tráiler de 40t.`,
          goodbye: `Saludos cordiales,`
        },
        nl: {
          subject: `Laaddatum bijgewerkt - Offerte ${vars.quoteIds}`,
          hello: `Hallo,`,
          body: `We hebben de laaddatum voor uw bestelling ${vars.quoteIds} bijgewerkt.\n\nNieuwe geschatte laaddatum: ${prettyDate}.\nControleer a.u.b. de toegang voor een 40-tons trekker-oplegger.`,
          goodbye: `Met vriendelijke groet,`
        },
      };
      const d = dict[lang] || dict['en'];
      return {
        subject: d.subject,
        message: `${d.hello}\n\n${d.body}\n\n${d.goodbye}`
      };
    },
    async buildEmailPreviewItems(isDateChange = false) {
      const items = [];
      const processedQuotationIds = new Set(); // Track processed quotations to avoid duplicates
      const deliveryAddress = this.getDeliveryAddressLabel();
      // Use estimated loading date for all emails (both new transporter and date change)
      const dateToUse = this.getEstimatedArrivalDate();
      const weight = this.operation_data && this.operation_data.transport_tonaj ? `${this.operation_data.transport_tonaj} t` : '40 t';

      // Helper to push item for a personId with given quoteIds
      const pushForPerson = async (personId, quoteIdsArr) => {
        try {
          // Deduplicate quoteIds to avoid processing same quotation twice
          const uniqueQuoteIds = [...new Set(quoteIdsArr)];

          const resp = await axios.get(`/people/data/${personId}`);
          const person = resp.data;
          const emailOptions = buildRecipientOptions(person);
          const defaultOptions = pickDefaultRecipients(emailOptions, 'general');
          const toEmail = defaultOptions.length > 0 ? defaultOptions[0].email : '';
          if (!toEmail) {
            console.warn(`[Email Transport] Skipping person ${personId} for quotes ${uniqueQuoteIds.join(', ')}: no email address found`);
            return; // skip if no email
          }
          const lang = this.getClientLanguageCode(person);
          const quoteIds = uniqueQuoteIds.map(id => `#${id}`).join(', ');
          const deliveryAddr = await this.getDeliveryAddressLabelFor(personId, uniqueQuoteIds[0]);
          // Use different localization function based on email type
          const loc = isDateChange
            ? this.localizeEmailDateChange(lang, { quoteIds, deliveryAddress: deliveryAddr, estimatedDate: dateToUse, weight })
            : this.localizeEmail(lang, { quoteIds, deliveryAddress: deliveryAddr, estimatedDate: dateToUse, weight });
          // Broker que le serveur mettra en Cc (affiché dans l'aperçu ; l'envoi
          // le recalcule lui-même à partir de operation_ids / person_ids).
          let brokerCc = '';
          try {
            const bc = await axios.get('/mail/broker-cc', { params: { operation_ids: uniqueQuoteIds.join(','), person_ids: personId } });
            brokerCc = ((bc.data && bc.data.emails) || []).join(', ');
          } catch (e) { brokerCc = ''; }
          items.push({ toEmail, emailOptions, subject: loc.subject, message: loc.message, quoteIds, lang, personId, quoteIdsArr: uniqueQuoteIds, brokerCc });
        } catch (e) {
          console.warn(`[Email Transport] Error building email for person ${personId} with quotes ${quoteIdsArr.join(', ')}:`, (e.response && e.response.status) || e.message || e);
        }
      };

      if (this.consolidateByClient) {
        // group by person id
        const groups = {};
        (this.invoiceattached || []).forEach(inv => {
          // Skip if already processed
          if (processedQuotationIds.has(inv.id)) return;
          processedQuotationIds.add(inv.id);

          const pid = null; // force resolution per quotation later to avoid relying on missing idperson
          if (!pid) return;
          if (!groups[pid]) groups[pid] = [];
          groups[pid].push(inv.id);
        });
        // If invoiceattached lacks person ids, resolve one by one
        for (let i = 0; i < (this.invoiceattached || []).length; i++) {
          try {
            const inv = this.invoiceattached[i];
            // Skip if already processed
            if (processedQuotationIds.has(inv.id)) continue;
            processedQuotationIds.add(inv.id);

            const opResp = await axios.get(`/operation/data/${inv.id}`);
            const op = opResp.data;
            const person = op && op.people && op.people.length ? op.people[0] : null;
            if (!person) {
              console.warn(`[Email Transport] Skipping quotation ${inv.id}: no person found in operation data`);
              continue;
            }
            const pid = person.id;
            if (!groups[pid]) groups[pid] = [];
            groups[pid].push(inv.id);
          } catch (e) {
            const invId = (this.invoiceattached[i] && this.invoiceattached[i].id) || 'unknown';
            console.warn(`[Email Transport] Error fetching operation data for quotation ${invId}:`, (e.response && e.response.status) || e.message || e);
          }
        }
        const keys = Object.keys(groups);
        for (let i = 0; i < keys.length; i++) {
          await pushForPerson(keys[i], groups[keys[i]]);
        }
      } else {
        // one email per invoice (quotation)
        for (let i = 0; i < (this.invoiceattached || []).length; i++) {
          const inv = this.invoiceattached[i];
          // Skip if already processed (deduplication)
          if (processedQuotationIds.has(inv.id)) continue;
          processedQuotationIds.add(inv.id);

          try {
            const opResp = await axios.get(`/operation/data/${inv.id}`);
            const op = opResp.data;
            const person = op && op.people && op.people.length ? op.people[0] : null;
            if (!person) {
              console.warn(`[Email Transport] Skipping quotation ${inv.id}: no person found in operation data`);
              continue;
            }
            await pushForPerson(person.id, [inv.id]);
          } catch (e) {
            console.warn(`[Email Transport] Error fetching operation data for quotation ${inv.id}:`, (e.response && e.response.status) || e.message || e);
          }
        }
      }

      // Final deduplication: remove duplicate emails for same person+quotation combination
      const emailMap = new Map();
      items.forEach(item => {
        const key = `${item.toEmail}_${item.quoteIds}`;
        if (!emailMap.has(key)) {
          emailMap.set(key, item);
        }
      });

      return Array.from(emailMap.values());
    },
    async previewEmails() {
      this.emailSendResults = { success: 0, fail: 0 };
      this.emailSendInProgress = false;
      this.emailPreviewItems = await this.buildEmailPreviewItems();
      this.showEmailPreview = true;
    },
    async sendTransportEmails() {
      // Prevent multiple simultaneous calls
      if (this.emailSendInProgress) {
        this.$vs.notify({
          color: 'warning',
          title: 'Sending in progress',
          text: 'An email sending is already in progress, please wait.'
        });
        return false; // Return false to indicate early return
      }

      if (!this.emailPreviewItems || !this.emailPreviewItems.length) {
        console.warn(`[Email Transport] sendTransportEmails called but no email preview items available`);
        this.$vs.notify({ 
          color: 'warning', 
          title: 'No emails to send', 
          text: 'No emails available to send. Please check that quotations are linked and clients have email addresses.' 
        });
        return false; // Return false to indicate early return
      }

      this.emailSendInProgress = true;
      // Show loading notification
      const loadingNotification = this.$vs.notify({
        color: 'primary',
        title: 'Sending emails...',
        text: 'Please wait, sending emails to clients...',
        time: 0, // Don't auto-close
      });

      const template_id = "template_cfvx026";

      // Log email sending start
      console.log(`[Email Transport] Starting to send ${this.emailPreviewItems.length} email(s)`);
      const recipientList = this.emailPreviewItems.map(it => `${it.toEmail} (${it.quoteIds})`).join(', ');
      console.log(`[Email Transport] Recipients: ${recipientList}`);

      // Track sent emails to avoid duplicates
      const sentEmails = new Set();

      for (let i = 0; i < this.emailPreviewItems.length; i++) {
        const it = this.emailPreviewItems[i];

        // Create unique key for this email (toEmail + quoteIds)
        const emailKey = `${it.toEmail}_${it.quoteIds}`;

        // Skip if already sent
        if (sentEmails.has(emailKey)) {
          console.log(`Skipping duplicate email: ${emailKey}`);
          continue;
        }
        sentEmails.add(emailKey);

        // Build signature HTML if helper exists, else empty string
        let signatureHtml = '';
        try {
          if (typeof this.getSignatureQuote === 'function') {
            signatureHtml = await this.getSignatureQuote(it.lang || 'en');
          }
        } catch (e) { signatureHtml = ''; }
        const dataz = {
          template_id,
          // Broker des devis (sinon celui de la fiche client) en Cc, côté serveur.
          operation_ids: it.quoteIdsArr,
          person_ids: [it.personId],
          template_params: {
            se_title: it.subject,
            se_hello: '',
            se_from_email: 'sales@acaciabois.com',
            se_message: it.message,
            se_goodbye: '',
            // Reply-to to Ferdinand + Mariana
            se_reply_mail: 'ferdinand.terlinden@acaciabois.com,mariana.nagy@xyloimpact.com',
            // CC Ferdinand + Mariana
            se_cc: 'ferdinand.terlinden@acaciabois.com,mariana.nagy@xyloimpact.com',
            se_mail: it.toEmail,
            se_from_name: "L'équipe commerciale - Acacia Bois / Xylo Impact",
            // Rich HTML signature (if available in template)
            se_signature: signatureHtml,
          },
        };
        try {
          await axios.post("/mail/send", dataz);
          this.emailSendResults.success++;
          console.log(`[Email Transport] ✓ Email sent successfully to ${it.toEmail} for quote(s) ${it.quoteIds}`);
          await new Promise(r => setTimeout(r, 250));
        } catch (e) {
          this.emailSendResults.fail++;
          const errorDetails = e.response 
            ? `Status: ${e.response.status}, Data: ${JSON.stringify(e.response.data)}`
            : `Message: ${e.message || 'Unknown error'}`;
          console.error(`[Email Transport] ✗ Error sending email to ${it.toEmail} for quote(s) ${it.quoteIds}:`, errorDetails, e);
        }
      }

      this.emailSendInProgress = false;
      // Close loading notification
      if (loadingNotification) {
        loadingNotification.close();
      }
      this.$vs.notify({
        color: this.emailSendResults.fail ? 'warning' : 'success',
        title: 'Email dispatch finished',
        text: `Sent: ${this.emailSendResults.success}, Failed: ${this.emailSendResults.fail}`
      });
      this.showEmailPreview = false;
      return true; // Return true to indicate emails were processed
      // Note: Redirection is handled by the caller to avoid double redirects
    },
    async buildEmailPreviewItemsFromIds(ids) {
      const items = [];
      // delivery address resolved per quotation below
      const estimatedDate = this.getEstimatedArrivalDate();
      const weight = this.operation_data && this.operation_data.transport_tonaj ? `${this.operation_data.transport_tonaj} t` : '40 t';
      for (let i = 0; i < (ids || []).length; i++) {
        const qid = ids[i];
        try {
          const opResp = await axios.get(`/operation/data/${qid}`);
          const op = opResp.data;
          const person = op && op.people && op.people.length ? op.people[0] : null;
          if (!person) continue;
          const toEmail = (person.email_bis || person.email || '').trim();
          if (!toEmail) continue;
          const lang = this.getClientLanguageCode(person);
          const quoteIds = [`#${qid}`].join(', ');
          const deliveryAddr = await this.getDeliveryAddressLabelFor(person.id, qid);
          const loc = this.localizeEmail(lang, { quoteIds, deliveryAddress: deliveryAddr, estimatedDate, weight });
          items.push({ toEmail, subject: loc.subject, message: loc.message, quoteIds, lang });
        } catch (e) {
          // skip
        }
      }
      return items;
    },
    async previewEmailForQuotation(quotationId) {
      this.consolidateByClient = false;
      this.emailSendResults = { success: 0, fail: 0 };
      this.emailSendInProgress = false;
      this.emailPreviewItems = await this.buildEmailPreviewItemsFromIds([quotationId]);
      this.showEmailPreview = true;
    }
  },

  created() {
    if (!moduleOperationList.isRegistered) {
      this.$store.registerModule("operationList", moduleOperationList);
      moduleOperationList.isRegistered = true;
    }
    this.fetch_operation_data(this.$route.params.userId);
    this.fetch_invoice_linked_data(this.$route.params.userId);
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>
